import React from "react";

import { useHistory } from 'react-router-dom/cjs/react-router-dom';
const TestResultSummaryCard = ({ result ,closeTestSummaryPopUp,downloadPdfLink}) => {
  const {
    accuracy,
    attemptNo,
    cutOff,
    durationTaken,
    score,
    speed,
    totalAttempted,
    totalCorrect,
    totalWrong,
    totalSkipped,
    totalQuestions,
  } = result;

  const isCleared = cutOff === "cleared";
  const attemptRatio = totalAttempted / totalQuestions;

  const showLowAttemptWarning = attemptRatio < 0.25;


  const history = useHistory();
  return (<> <div  onClick={()=>{  history.push('/');}}   className="mockTestV1PopUpHintOpacityHint"  style={{cursor:"pointer"}}> </div>
        <div   className="mockTestV1PopUpHint" style={{borderRadius: '20px'}}> 
       
 
<div style={{}}>
 


    <div style={styles.wrapper}>
      {/* Header */}
      <div style={styles.header}>
        <h4> <div align="center" >   <span className="" style={{fontSize:"24px"}} >Result Summary </span> </div>
      Test Submitted</h4>
        <span
          style={{
            ...styles.status,
            backgroundColor: isCleared ? "#16a34a" : "#dc2626",
          }}
        >
          {isCleared ? "Cleared" : "Not Cleared"}
        </span>
      </div>

      {/* Accuracy Ring + Stats */}
      <div style={styles.topRow}>
        <AccuracyRing accuracy={accuracy} downloadPdfLink={downloadPdfLink} />

        <div style={styles.sideStats}>
          <StatLine label="Score" value={score} />
          <StatLine label="Speed" value={speed} />
          <StatLine
            label="Attempted"
            value={`${totalAttempted}/${totalQuestions}`}
          />
        </div>
      </div>

      {/* Low Attempt Warning */}
      {showLowAttemptWarning && (
        <div style={styles.warningBox}>
          ⚠️ <b>Low Attempt Alert:</b>{" "}
          {accuracy >= 80
            ? "Accuracy is good, but you attempted very few questions. Try increasing attempts to improve score."
            : "Very few questions attempted. Improve attempt rate along with accuracy."}
        </div>
      )}

      {/* Attempt Summary */}
      <div style={styles.section}>
        <h4>Attempt Summary</h4>
        <div style={styles.grid}>
          <Info label="Correct" value={totalCorrect} />
          <Info label="Wrong" value={totalWrong} />
          <Info label="Skipped" value={totalSkipped} />
          <Info label="Accuracy" value={`${accuracy}%`} />
        </div>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <span>⏱ {durationTaken}s</span>
        <span>Attempt #{attemptNo}</span>
      </div>
    </div><div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"20px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
  <a   style={{position:"relative",border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)",cursor:"pointer",zIndex:99999,height:"35px",width:"120px",display:"flex",justifyContent:"center",alignItems:"center"}} 
  className=" MocktestHintBtn"  href={downloadPdfLink} target="_blank" >Download PDF</a>
<button  onClick={()=>{ history.push('/');}}   style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" MocktestHintBtn"  type="submit"
 > Close </button>
</div> 
</div></div><style>{`



 .mockTestHintTextbox, .mockTestHintTextbox:hover, .mockTestHintTextbox:focus{
    background: #f9f9f9;
    box-shadow:var(--shadow-default);
   color:#222;
   padding: 15px;
   margin:10px;outline: #fff;
   border: 3px solid rgba(144, 202, 249,1) !important;
   border-radius: 10px;;
}
  
.MocktestHintBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  
.mockTestColoredTextV1Hint {
         animation: background-pan-b24b2865 0.9s linear infinite;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
 
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #8142e3, #86c2ff);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
.mockTestV1PopUpHintOpacityHint{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.061);
        z-index:9999999999 !important}
        
        .mockTestV1PopUpHint{position:fixed;
    left:20%;
    right:20%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:10%;bottom:10%;
    padding:15px;
    z-index:99999999999 !important;}

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
    .mockTestV1PopUpHint{position:fixed;top:0px;
        left:20%;
        right:20%;top:12%;
       }}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
  .mockTestV1PopUpHint{position:fixed;top:0px;
                left:20%;
                right:20%;top:12%;
               }} 

/* xs */
@media (max-width: 767px) {
    .hideXS{display:none !important ;}
    .mockTestV1PopUpHint{
       
        top:0px!important; height:100% !important;
        left:0%;border-radius: 0px !important;
        right:0%;
        bottom:0%!important;
    }
        }
        `}</style></>
  );
};

/* ===========================
   Accuracy Ring Component
=========================== */

const AccuracyRing = ({ accuracy ,downloadPdfLink}) => {
  const radius = 42;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (accuracy / 100) * circumference;

  let color = "#16a34a";
  if (accuracy < 80) color = "#f59e0b";
  if (accuracy < 50) color = "#dc2626";

  return (<>
    
    <div style={styles.ringWrapper}>
      <svg width="110" height="110">
        <circle
          cx="55"
          cy="55"
          r={radius}
          stroke="#e5e7eb"
          strokeWidth="10"
          fill="none"
        />
        <circle
          cx="55"
          cy="55"
          r={radius}
          stroke={color}
          strokeWidth="10"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 55 55)"
        />
      </svg>
      <div style={styles.ringText}>
        <div style={styles.ringValue}>{accuracy}%</div>
        <div style={styles.ringLabel}>Accuracy</div>
      </div>
    </div>
    <a   style={{position:"relative",border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)",cursor:"pointer",zIndex:99999,height:"35px",width:"120px",display:"flex",justifyContent:"center",alignItems:"center"}} 
  className=" MocktestHintBtn hideXS"  href={downloadPdfLink} target="_blank" >Download PDF</a>

     </>
  );
};

/* ===========================
   Small Components
=========================== */

const StatLine = ({ label, value }) => (
  <div style={styles.statLine}>
    <span>{label}</span>
    <b>{value}</b>
  </div>
);

const Info = ({ label, value }) => (
  <div>
    <small style={{ color: "#6b7280" }}>{label}</small>
    <div style={{ fontWeight: 600 }}>{value}</div>
  </div>
);

/* ===========================
   Styles
=========================== */

const styles = {
  wrapper: {
    maxWidth: 520,
    margin: "40px auto",
    padding: 20,
    borderRadius: 16,
    background: "#ffffff",
    boxShadow: "0 12px 35px rgba(0,0,0,0.08)",
    fontFamily: "Inter, sans-serif",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  status: {
    color: "#fff",
    padding: "6px 14px",
    borderRadius: 20,
    fontSize: 14,
  },
  topRow: {
    display: "flex",
    gap: 20,
    marginTop: 20,
    alignItems: "center",
  },
  ringWrapper: {
    position: "relative",
    width: 110,
    height: 110,
  },
  ringText: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  ringValue: {
    fontSize: 20,
    fontWeight: 700,
  },
  ringLabel: {
    fontSize: 12,
    color: "#6b7280",
  },
  sideStats: {
    flex: 1,
  },
  statLine: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 8,
    fontSize: 14,
  },
  warningBox: {
    marginTop: 16,
    padding: 12,
    background: "#fff7ed",
    border: "1px solid #fed7aa",
    borderRadius: 10,
    fontSize: 14,
    color: "#9a3412",
  },
  section: {
    marginTop: 20,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    marginTop: 10,
  },
  footer: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    fontSize: 13,
    color: "#374151",
  },
};

export default TestResultSummaryCard;
